/**
 * UI click sounds (yknytt ClickPlayer: Sfx/Menu Click.flac on every menu button,
 * pause-panel button, level-select entry and cutscene page advance). Standalone —
 * the menu runs before any Game/AudioManager exists, so this keeps its own lazy
 * AudioContext. Honours the persisted mute (localStorage 'knytt-muted').
 */
const DATA_BASE = `${import.meta.env.BASE_URL}data/`;

let ctx: AudioContext | null = null;
const buffers = new Map<string, Promise<AudioBuffer | null>>();

function isMuted(): boolean {
  try {
    return globalThis.localStorage?.getItem('knytt-muted') === '1';
  } catch {
    return false;
  }
}

/**
 * Play a one-shot UI sound by data-relative path. Swappable for per-page cutscene
 * sounds (soundN.ogg) by passing a different path.
 */
export function playUiSound(path = 'Sfx/Menu Click.flac', volume = 0.9): void {
  if (isMuted()) return;
  try {
    ctx ??= new AudioContext();
  } catch {
    return;
  }
  if (ctx.state === 'suspended') void ctx.resume();
  let p = buffers.get(path);
  if (!p) {
    p = (async () => {
      try {
        const resp = await fetch(`${DATA_BASE}${path}`);
        if (!resp.ok) return null;
        return await ctx!.decodeAudioData(await resp.arrayBuffer());
      } catch {
        return null;
      }
    })();
    buffers.set(path, p);
  }
  void p.then((buf) => {
    if (!buf || !ctx || isMuted()) return;
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const g = ctx.createGain();
    g.gain.value = volume;
    src.connect(g).connect(ctx.destination);
    src.start();
  });
}

/** The default menu click (ClickPlayer). */
export function playUiClick(): void {
  playUiSound();
}
